///<reference path="../references.d.ts"/>
namespace Roodik.Game
{
	import IAnalytics = Roodik.Core.IAnalytics;
	import IGameResources = Roodik.Core.IGameResources;
	import FontLoader = Roodik.Core.FontLoader;
	
	export class Main extends Roodik.Core.Scene
	{
		private _preloader : Preloader;
		private _gameLifeCycle : GameLifeCycle;
		private _analytics : IAnalytics;
		private _gameResources : GameResources = new GameResources();
		
		constructor(htmlElement : HTMLElement, styleSheet)
		{
			super(htmlElement, styleSheet);

			this._analytics = new MahjongAnalyticsManager();
			this._gameLifeCycle = new GameLifeCycle(this,
			this.GAME_WIDTH,
			this.GAME_HEIGHT,
			this._analytics,
			this.resources);
			
			this._gameResources.loadDbLazy("preloader", "resources/preloader/",
			() => {},
			()=>{
				this._preloader = new Preloader();
				this.addChild(this._preloader);
				
				this._gameResources.loadMixedLazy(this.loadProgress.bind(this), this.resourcesLoaded.bind(this));
			});
		}
		
		private loadProgress(progress : number)
		{
			this._preloader.update(progress);
		}
		
		private resourcesLoaded()
		{
			let fontLoader = new FontLoader("WellWait", ()=>
			{
				this._preloader.destroy();
				this.removeChild(this._preloader);
				this._preloader = null;
				this._gameLifeCycle.run();
			});
		}
		
		protected update()
		{
			if (this._gameLifeCycle != null)
			{
				this._gameLifeCycle.update();
			}
			super.update();
		}
		
		public get resources() : IGameResources
		{
			return this._gameResources;
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/Main.ts